<div class="container">
  <p class="title">Your session has expired</p>
  <p class="subtitle">Please sign in to open Unleash.</p>
  <u-button label="Sign in" (onClick)="signIn.emit()" [styles]="{ width: '100%' }" type="primary"></u-button>
</div>
